import React from 'react';
import { Select } from 'antd';
import Field from '../../../../shared/ui/Field';
import {
  registrationStateTypes,
  useRegistrationControllers,
  useRegistrationSubscribe,
} from '../../../../services/acceptanceRegistration';
import { formatPhoneNumber } from '../../../../../../helpers/formatPhoneNumber';
import { useAddOwnerSelectProps } from '../AddRegistrationOwner';

const PHONE_FORMAT = {
  format: '(xxx) xxx-xx-xx',
  placeholder: 'x',
};

const formatClientPhone = (phone) =>
  phone ? formatPhoneNumber({ phoneNumber: phone, ...PHONE_FORMAT }) : '';

const SelectOwner = () => {
  const clients = useRegistrationSubscribe({
    type: registrationStateTypes.owners,
    selector: (payload) => payload.value,
  });

  const ownerId = useRegistrationSubscribe({
    type: registrationStateTypes.selectedOwner,
    selector: (payload) => payload.value?.id,
  });

  const { selectOwner } = useRegistrationControllers();
  const addOwnerSelectProps = useAddOwnerSelectProps();

  const handleChange = (_value, option) => {
    selectOwner(option?.props?.data);
  };

  return (
    <Field
      {...addOwnerSelectProps}
      type={Field.types.select}
      value={ownerId}
      onChange={handleChange}
      formItemLabel="Выбор собственника"
      required
      style={{ width: '100%' }}
      optionFilterProp="search"
      showSearch={clients?.length > 10}
      allowClear
    >
      {clients?.map((client) => (
        <Select.Option
          key={client.id}
          value={client.id}
          search={client.name}
          data={client}
        >
          {`${client.name} ${formatClientPhone(client.phone)}`}
        </Select.Option>
      ))}
    </Field>
  );
};

export default SelectOwner;
